import { create } from "zustand";

type ChecklistProgressState = {
	currentStep: number;
	currentSection: number;
	totalSteps: number;
	setCurrentStep: (step: number) => void;
	setTotalSteps: (total: number) => void;
	nextStep: () => void;
	prevStep: () => void;
	isFirstStep: () => boolean;
	isLastStep: () => boolean;
	setInitialState: () => void;
};
const initialState = {
	currentStep: 1,
	currentSection: -1,
	totalSteps: 1,
};

export const useChecklistProgressStore = create<ChecklistProgressState>(
	(set, get) => ({
		...initialState,
		setCurrentStep: (step) => set({ currentStep: step }),
		setTotalSteps: (total) => set({ totalSteps: total }),
		nextStep: () =>
			set(({ currentStep, totalSteps, currentSection }) => ({
				currentStep: Math.min(currentStep + 1, totalSteps),
				currentSection: currentSection + 1,
			})),
		prevStep: () =>
			set(({ currentStep, currentSection }) => ({
				currentStep: Math.max(currentStep - 1, 1),
				currentSection: currentSection - 1,
			})),
		isFirstStep: () => get().currentStep === 1,
		isLastStep: () => get().currentStep === get().totalSteps,
		setInitialState: () => set(initialState),
	})
);
